import * as React from 'react';

import { FinanceLineItemData, FinanceLineItemErrors } from '../types';

import { DescriptionCell } from './DescriptionCell';

import { useTranslations } from '@/finance/i18n/useTranslations';

interface DescriptionFieldCellProps {
  lineItem: FinanceLineItemData;
  onUpdate: (id: string, updates: Partial<FinanceLineItemData>) => void;
  disabled?: boolean;
  errors?: FinanceLineItemErrors;
}

export const DescriptionFieldCell: React.FC<DescriptionFieldCellProps> = ({
  lineItem,
  onUpdate,
  disabled = false,
  errors,
}) => {
  const t = useTranslations();

  const handleChange = React.useCallback(
    (description: string, itemId: string | null) => {
      onUpdate(lineItem.id, { description, itemId });
    },
    [lineItem.id, onUpdate],
  );

  return (
    <DescriptionCell
      value={lineItem.description}
      itemId={lineItem.itemId}
      onChange={handleChange}
      isDisabled={disabled}
      isInvalid={!!errors?.description}
      errorMessage={errors?.description}
      selectPlaceholder={t.lineItems.placeholders.selectItem}
      textPlaceholder={t.lineItems.placeholders.enterDescription}
      className="@DescriptionFieldCell"
    />
  );
};
